<template>
  <div class="auth-code-page" id="auth-code-page">

    <app-loading
        v-if="loading"
    />

    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'transparent'"
        :infoButton="false"
        @clickMenu="change_menu(context, true)"
    />

    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="change_menu(context, false)"
          @clickOutside="change_menu(context, false)"
      />
    </transition >


    <div class="auth-code-page__title">
      Введите код из смс
    </div>

    <app-input-code
        :error="error.status"
        :clear="is_clear"
        @changeButton="({ status, value }) => {
            is_button_active = status
            if(status) {
             code = value
             auth_code_validate(context, { create_order: false, redirect: ('/check-order') })
            }
          }"
        @clearEnd="() => {
            is_clear = false
            is_button_active = false
          }"
    />

    <div class="auth-code-page__again"
         @click="auth_code_send_again(context)"
    >
      Отправить смс еще раз
    </div>


    <div class="auth-code-page__counter-text" v-if="time.total > 0">
      Запросить новый код можно через:
    </div>

    <div class="auth-code-page__counter-time" v-if="time.total > 0">
      {{ time.minutes }}:{{ time.seconds }}
    </div>

    <div class="auth-code-page__button-wrapper">
      <div class="auth-code-page__button"
           :class="{'auth-code-page__button-active' : is_button_active}"
      >
        <span>Далее</span>
      </div>
    </div>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >

      <app-alert
          v-if="error.status"
          buttonText="ОК"
          :text="error.text"
          @clickGrowButtonPopup="() => {
              error.status = false
              overlay = false
              loading = false
            }"
      />

    </transition>
  </div>
</template>

<script>

const AppHeader = () => import('@/components/header.vue')
const AppMenu = () => import('@/components/menu.vue')
const AppOverlay = () => import('@/components/overlay.vue')
const AppLoading = () => import('@/components/loading.vue')
const AppAlert = () => import('@/components/popups/error')
const AppInputCode = () => import('@/components/input-code')

import auth_counter_time from "@/views/auth/modules/auth_counter_time";
import building_videos from "@/views/survey/modules/building_videos";
import auth_code_mounted_hook from "@/views/auth/modules/auth_code_mounted_hook";
import change_menu from "@/views/theme/modules/change_menu";
import auth_code_clear_form from "@/views/auth/modules/auth_code_clear_form";
import auth_code_send_again from "@/views/auth/modules/auth_code_send_again";
import auth_code_validate from "@/views/auth/modules/auth_code_validate";

export default {
  async mounted() {
    await this.auth_code_mounted_hook(this)
  },
  data() {
    return  {
      context: this,
      menu: false,
      overlay: false,
      is_clear: false,
      code: false,
      loading: false,
      videos: [],
      is_button_active: false,
      time: {
        minutes: '00',
        seconds: '00',
        total: 0
      },
      error: {
        status: false,
        text: ''
      }
    }
  },
  components: {
    AppHeader,
    AppMenu,
    AppOverlay,
    AppLoading,
    AppAlert,
    AppInputCode
  },
  methods: {
    auth_counter_time,
    building_videos,
    auth_code_mounted_hook,
    change_menu,
    auth_code_clear_form,
    auth_code_send_again,
    auth_code_validate
  },
  computed: {
    phone() {
      return this.$store.getters['auth/phone']
    },
    checkMusicId() {
      return this.$store.getters['music/music'] ? this.$store.getters['music/music'].id : false
    },
    priceSurvey() {
      return this.$store.getters['survey_price/selectSurveyPrice']
    },
    priceSurveyName() {
      return this.$store.getters['survey_price/selectSurveyName']
    },
    price() {
      return this.$store.getters['price/price']
    },
    entry() {
      return this.$store.getters['entry_video/entry']
    },
    main() {
      return this.$store.getters['main_videos/main']
    },
    ending() {
      return this.$store.getters['ending_video/ending']
    },
    timestamp() {
      return this.$store.getters['auth/code_timestamp']
    },
    waitingPayment() {
      return this.$store.getters['settings/waitingPayment']
    }
  }
}
</script>

<style lang="less">
.auth-code-page {
  background-color: #2F1F4C;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
}

#auth-code-page .header-component {
  justify-content: flex-end;
}

#auth-code-page .header-component__arrow {
  display: none;
}

@import '~/assets/fonts/montserrat/Montserrat-Bold.less';

.auth-code-page__title {
  color: #FFFFFF;
  font-size: 19px;
  font-family: 'Montserrat-Bold';
}

.auth-code-page__inputs {
  display: flex;
  align-items: center;
  margin-top: 24px;
}

.auth-code-page__inputs input {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.15);
  outline: none;
  border: none;
  margin-right: 8px;
  font-size: 24px;
  padding-left: 20px;
  color: #B8B4C0;
}

@import '~/assets/fonts/roboto/Roboto-Light.less';

.auth-code-page__again {
  color: #958FA5;
  font-size: 15px;
  font-family: 'Roboto-Light';
  line-height: 20px;
  margin-top: 22px;
  border-bottom: 1px dashed #958FA5;
  cursor: pointer;
}

.auth-code-page__counter-text {
  font-family: 'Roboto-Light';
  margin-top: 22px;
  font-size: 13px;
  color: #958FA5;
}

.auth-code-page__counter-time {
  font-family: 'Roboto-Light';
  margin-top: 10px;
  font-size: 22px;
  color: #ffffff;
}

.auth-code-page__button-wrapper {
  width: 100%;
  position: absolute;
  bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@import '~/assets/fonts/montserrat/Montserrat-Medium.less';

.auth-code-page__button {
  width: 343px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #31283D;
  line-height: 12px;
  font-size: 16px;
  font-family: 'Montserrat-Medium';
  background-color: #fff;
  border-radius: 5px;
  opacity: .3;
}

.auth-code-page__button-active {
  opacity: 1;
}

.auth-code-page__inputs-error input {
  border: 1px solid #af3030;
  // box-shadow: 1px 1px 1px black;
}
</style>
